import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3ad2c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = { class: "header-right" }
const _hoisted_3 = { class: "header-menu__icon" }
const _hoisted_4 = { class: "header-pagename" }
const _hoisted_5 = { class: "header-info" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "header-info--business"
}

import { ref, onMounted, watchEffect, getCurrentInstance } from 'vue'
import { Fold, Expand } from '@element-plus/icons-vue'
import userbar from './userbar.vue'
import { useRoute } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { getMenuTitle } from '@/utils/lang'
import { isOfficialRole } from '@/utils/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
  // 是否收缩菜单
  isFold: { type: Boolean, default: false }
  // 是否为KEBS账号
  // isKEBS: { type: Boolean, default: false }
},
  emits: ['isFoldChange'],
  setup(__props, { emit }) {

const props = __props

const store = useMainStore()
const route = useRoute()

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const isShowAllType = ref(true)
const isShowType = ref(false)

// 菜单收缩
const onShrinkMenu = () => {
  emit('isFoldChange', !props.isFold)
}

const pageTitle = ref<string>('')
// 当前是否为微应用
const isQiankun = ref(false)

// 选择业务
const businessType = ref<any>(0)

// 切换业务
const onChangeBusiness = (val: number) => {
  localStorage.setItem('APPLY_TYPE', val)
  location.reload()
}
const applyTypeList = ref<any>([])
const allApplyType = {
  applicationBriefName: t('parameterManagement.allType'), // 全部类型
  applicationBriefNameEn: t('parameterManagement.allType'), // 全部类型
  id: 0,
  applyTypeCode: '',
  countryId: ''
}

// 初始化申请类型列表（数据来源于路由守卫中已处理的 store.inspectAllApplyType）
const initApplyTypeData = () => {
  const list = store.inspectAllApplyType || []
  applyTypeList.value = [allApplyType, ...list]
}
onMounted(() => {
  businessType.value = localStorage.getItem('APPLY_TYPE') ? Number(localStorage.getItem('APPLY_TYPE')) : 0
  pageTitle.value = getMenuTitle(route.meta, t) // lang === 'en' ? route.meta.titleEn as string : route.meta.title as string
  if ((window as any).__POWERED_BY_QIANKUN__) {
    isQiankun.value = true
  }
  initApplyTypeData()
})
watchEffect(() => {
  // 当前菜单
  if (route.meta && route.meta.title) {
    pageTitle.value = getMenuTitle(route.meta, t) // lang === 'en' ? route.meta.titleEn as string : route.meta.title as string
    store.updateCurrentMenu(route.meta)
  }
  // 判断是否展示切换类型
  // const pageList = store.PermissionMenuList[1].children
  const pageList = store.PermissionMenuList?.find(
    menu => menu.slug === 'inspectionSystem'
  )?.children || []
  const checkPathExists = (paths: any, targetPath: any) => {
    if (targetPath.includes('contractReport') || targetPath.endsWith('rfcInspectionReport')) {
      return true
    }
    if (targetPath.includes('KebsQueries')) { // targetPath.includes('KenyaOfficial') || targetPath.includes('port')
      return false
    }
    for (const item of paths) {
      // 检查当前对象的path
      if (item.routePath === targetPath || targetPath === '/') {
        return true
      }
      // 检查当前对象的子对象（如果有的话）
      if (item.children && item.children.length > 0) {
        for (const child of item.children) {
          if (child.routePath === targetPath) {
            return true
          }
        }
      }
    }
    return false
  }
  isShowAllType.value = checkPathExists(pageList, route.path)
  // 判断是否为官方角色，官方角色隐藏类型选择（业务类型已在路由守卫中自动匹配）
  if (store.rolesList && store.rolesList.length) {
    isShowType.value = !isOfficialRole()
  } else {
    isShowType.value = true
  }
})
// 跳转工作台
const pushPage = () => {
  if (isQiankun.value) {
    window.location.href = window.location.origin
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!__props.isFold)
          ? (_openBlock(), _createBlock(_unref(Fold), {
              key: 0,
              style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
              onClick: onShrinkMenu
            }))
          : _createCommentVNode("", true),
        (__props.isFold)
          ? (_openBlock(), _createBlock(_unref(Expand), {
              key: 1,
              style: {"color":"#000000","width":"22px","height":"22px","cursor":"pointer"},
              onClick: onShrinkMenu
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageTitle.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (isQiankun.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              plain: "",
              size: "small",
              class: "header-info__btn",
              onClick: pushPage
            }, {
              default: _withCtx(() => [
                _createTextVNode("工作台")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isShowAllType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (isShowType.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_el_select, {
                      modelValue: businessType.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((businessType).value = $event)),
                      onChange: onChangeBusiness,
                      class: "header-info__select",
                      placeholder: _ctx.$t('header.businessType')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyTypeList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.applicationBriefName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(userbar)
      ])
    ])
  ]))
}
}

})